import styled, { css } from "styled-components";
import { StyleForm } from "./FormContainer.types";
import { devices,colors } from "../../utils/styled/_variables.styled";

export const FormContainerBox = styled.div<StyleForm>`
  background-color: ${(props) =>
    props.$themeChange ? "#162c2b" : props.$backgroundColor};
  display: flex;
  gap: 40px;
  padding: 40px 24px;
  flex-direction: column;

  &:has(.cmp-image) {
    padding: 40px 0 40px 24px !important;
    > div:nth-of-type(2) {
      width: 400px;
      height: 480px;
      position: sticky;  
      top: 100px;
      z-index: 1;
      
    }
    @media ${devices.tablet} {
      flex-direction: column-reverse;
      padding: 0 !important;
      gap: 0 !important;

      > div:first-child {
        padding: 48px;
      }

      > div:nth-of-type(2) {
        width: 100% !important;
        height: auto !important;
        position: static !important;

      }

      .style-container .cmp-image {
        margin-bottom: 0;
      }
    }

    @media ${devices.mobile} {
      flex-direction: column-reverse;
      padding: 0 !important;
      gap: 0 !important;

      > div:first-child {
        padding: 16px;
      }

      > div:nth-of-type(2) {
        width: 100% !important;
        height: auto !important;
        position: static !important;
      }

      .style-container .cmp-image {
        max-width: 100vw !important;
        margin: 0 !important;
      }
    }
  }

  flex-direction: row;

  .style-container {
    width: 100%;
  }
  @media ${devices.desktop} {
    padding: 60px 116px;
    flex-direction: row;
  }
  
  ${(props) =>
    props.$themeChange &&
    css`
      .formSimulation{
        @media ${devices.mobile} {
          .title-form{
            font-size: 18px !important;
            padding: 0px 0px 8px 0px !important;
          }
          .subtitle-form{
            font-size: 14px !important;
          }
          
        }
        background-color: #162C2B !important;
        .title-form{
          font-size: 24px;
          padding: 0px 0px 12px 0px;
          color: #B8CAA6 !important;
        }
        .subtitle-form{
          color: #B8CAA6 !important;
        }
        input{
          color: ${colors.white};
          background-color: #162C2B !important;
        }
        select{
          color: ${colors.white};
          background-color: #162C2B !important;
        }
        option{
          color: ${colors.white};
          background-color: #162C2B !important;
        }
        label{
          color: ${colors.white};
        }
        p{
          color: ${colors.white};
        }
        #btn-simulacao{
          color: #203633;
          background-color: #B7CAA6;

          &:hover {
            background-color: #B7CAA6;
          }

          &:disabled {
            background-color: ${colors.gray3};
            color: ${colors.gray4};
          }
        }
      }
    
    `}
  


.style-container{
  width: 100%;
}

  .title__text__container {
    margin-right: 0px;

    @media ${devices.desktop} {
      margin-right: 60px;
    }

    .title__text .title__text__content .title__text__subtitle {
      font-weight: 700;
      font-size: 32px;
      line-height: 110.00000000000001%;
      letter-spacing: 0px;

      @media ${devices.desktop} {
        font-size: 40px;
      }
    }

    .title__text .title__text__content .title__text__text {
      font-weight: 400;
      font-size: 16px;
      line-height: 175%;
      letter-spacing: 0%;

      @media ${devices.desktop} {
        font-size: 18px;
      }
    }
  }
`;

export const visuallyHiddenStyles: React.CSSProperties = {
  position: 'absolute',
  width: '1px',
  height: '1px',
  padding: 0,
  margin: '-1px',
  overflow: 'hidden',
  clip: 'rect(0, 0, 0, 0)',
  whiteSpace: 'nowrap',
  border: 0,
};
